import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {currentYear} Yo Amo Bazurto. Todos los derechos reservados.</p>
        <div className="footer-separator"></div>
        <p>Developed by <a href="https://www.limitlesscol.com" target="_blank" rel="noopener noreferrer">Limitless Solutions</a></p>
      </div>
    </footer>
  );
}

export default Footer;
